import constants from '@/shared/constants/constants';
import {
  createDesignBoardSettingApi,
  deleteDesignBoardSettingApi,
  listDesignBoardSettingsApi,
  updateDesignBoardSettingApi,
} from '@/services/designBoard.service';

const state = {
  settings: [],
  loading: false,
};

const mutations = {
  SET_SETTINGS(current, rows) {
    current.settings = rows;
  },
  SET_LOADING(current, loading) {
    current.loading = loading;
  },
};

const actions = {
  async fetchSettings({ commit }) {
    commit('SET_LOADING', true);
    try {
      const { status, data } = await listDesignBoardSettingsApi();
      if (status === constants.HTTP_OK) {
        const rows = Array.isArray(data) ? data : (data && data.data) || [];
        commit('SET_SETTINGS', rows);
      }
      return { status, data };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async fetchSettingsTable(_ctx, params) {
    const { status, data } = await listDesignBoardSettingsApi(params);
    return { status, data };
  },
  async createSetting({ commit }, payload) {
    commit('SET_LOADING', true);
    try {
      const { status, data } = await createDesignBoardSettingApi(payload);
      return { status, data };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async updateSetting({ commit }, { id, payload }) {
    commit('SET_LOADING', true);
    try {
      const { status, data } = await updateDesignBoardSettingApi(id, payload);
      return { status, data };
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async deleteSetting({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const { status, data } = await deleteDesignBoardSettingApi(id);
      return { status, data };
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
